"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBusinessMemberRoleRequestToJSON = exports.UpdateBusinessMemberRoleRequestFromJSONTyped = exports.UpdateBusinessMemberRoleRequestFromJSON = exports.instanceOfUpdateBusinessMemberRoleRequest = void 0;
var runtime_1 = require("../runtime");
var BusinessRole_1 = require("./BusinessRole");
/**
 * Check if a given object implements the UpdateBusinessMemberRoleRequest interface.
 */
function instanceOfUpdateBusinessMemberRoleRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateBusinessMemberRoleRequest = instanceOfUpdateBusinessMemberRoleRequest;
function UpdateBusinessMemberRoleRequestFromJSON(json) {
    return UpdateBusinessMemberRoleRequestFromJSONTyped(json, false);
}
exports.UpdateBusinessMemberRoleRequestFromJSON = UpdateBusinessMemberRoleRequestFromJSON;
function UpdateBusinessMemberRoleRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'role': !(0, runtime_1.exists)(json, 'role') ? undefined : (0, BusinessRole_1.BusinessRoleFromJSON)(json['role']),
    };
}
exports.UpdateBusinessMemberRoleRequestFromJSONTyped = UpdateBusinessMemberRoleRequestFromJSONTyped;
function UpdateBusinessMemberRoleRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'role': (0, BusinessRole_1.BusinessRoleToJSON)(value.role),
    };
}
exports.UpdateBusinessMemberRoleRequestToJSON = UpdateBusinessMemberRoleRequestToJSON;
